export default function updateUserReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_USER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_USER_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_USER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}